import useSWRMutation from 'swr/mutation';
import urlResolver from 'edrolo/utils/URLResolver';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { useAnalytics } from 'edrolo/analytics';

async function createTaskRequest(key: string) {
  const csrftoken: string = Cookies.get('csrftoken') || '';

  return fetch(key, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken,
    },
  });
}

const useCreateTask = () => {
  const { trigger } = useSWRMutation(
    urlResolver.reverse('api:tasks'),
    createTaskRequest
  );

  return {
    createTask: () => trigger(),
  };
};

interface Options {
  courseId: CourseId | undefined;
  topicId: TopicId | undefined;
  examId: ExamId | undefined;
}

export const useCreateAndNavigateToTask = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { createTask } = useCreateTask();
  const history = useHistory();
  const { track } = useAnalytics({});

  async function createAndNavigateToTask(options?: Partial<Options>) {
    setIsLoading(true);

    const response = await createTask();
    const task = await response.json();

    const urlSearchParams = new URLSearchParams({
      ...(options?.courseId && { courseIds: `${options.courseId}` }),
      ...(options?.topicId && { topicIds: `${options.topicId}` }),
      ...(options?.examId && { examIds: `${options.examId}` }),
    });

    const url = `${urlResolver.reverse('task-page', {
      taskId: task.id,
    })}?${urlSearchParams.toString()}`;

    track('Create Task - Started', {
      task_id: task.id,
    });

    setIsLoading(false);
    history.push(url);
  }

  return {
    createAndNavigateToTask,
    isLoading,
  };
};
